import Link from 'next/link';
import Program from 'wwg-utilities/dist/collections/program';
import Provider from 'wwg-utilities/dist/collections/provider';
import MessageBubbleIcon from '../../icons/MessageBubble';
import LocationIcon from '../../icons/Location';
import getAddressLineString from 'wwg-utilities/dist/sharedFunctions/getAddressLine';
import getCityStateZipString from 'wwg-utilities/dist/sharedFunctions/getCityStateZipString';

interface ContactProps {
  program: Program;
}

const Contact: React.FC<ContactProps> = ({ program }) => {
  return (
    <>
      <hr className="mx-4 my-10" />
      <h3 className="mx-4 text-2xl font-bold lg:mx-0 text-primary-dark">
        Contact
      </h3>

      <section className="grid grid-cols-1 px-4 my-4 md:grid-cols-2 lg:px-0">
        <div>
          <div className="flex items-center">
            <figure className="flex items-center justify-center p-2 bg-primary">
              <MessageBubbleIcon className="h-6 stroke-white fill-white" />
            </figure>
            <h4 className="ml-4 text-xl font-bold text-primary-dark">
              Who do I contact?
            </h4>
          </div>
          <div className="flex items-center my-6 lg:flex-col lg:items-start xl:flex-row">
            {program.contactData?.email && (
              <p className="mr-2 text-left underline text-md lg:ml-2">
                <Link
                  href={`mailTo: ${program.contactData?.email}`}
                  target="_blank"
                >
                  Email
                </Link>
              </p>
            )}
            {program.contactData?.phone && (
              <p className="mx-2 text-left underline text-md">
                <Link href={`tel:${program.contactData?.phone}`}>
                  {`Call: ${program.contactData?.phone}`}
                </Link>
              </p>
            )}
            {program.contactData?.url && (
              <p className="ml-2 text-left underline text-md">
                <Link href={program.contactData?.url || ''} target="_blank">
                  Website
                </Link>
              </p>
            )}
          </div>
        </div>
        <div>
          <div className="flex items-center">
            <figure className="flex items-center justify-center p-2 bg-primary">
              <LocationIcon className="h-6 stroke-white fill-white" />
            </figure>
            <h4 className="ml-4 text-xl font-bold text-primary-dark">
              {(program.institution as Provider).name}
            </h4>
          </div>
          <div className="my-6">
            <p className="leading-5 text-md">
              {getAddressLineString(program.address)}
              <br />
              {getCityStateZipString(program.address)}
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
